<template>
  <div class="main-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="home-log">
          <img src="@/assets/img/home-edu.png" />
        </span>
        <span class="main-color">预约管理</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin-top:10px">
      <el-card shadow="never">
        <div style="margin:10px 0 ">
          <div>
            <el-button type="primary" @click="addInfo">新增</el-button>
          </div>
        </div>
        <el-table :data="tableData" border :header-cell-style="$method.titleClass" style="margin-top:10px">
          <el-table-column type="index" align="center" width="75" label="序号" :index="indexShow"></el-table-column>
          <el-table-column prop="medical_exam_date" align="center" label="预约日期"></el-table-column>
          <el-table-column prop="number" align="center" label="总人数"></el-table-column>
          <el-table-column prop="preengage_number" align="center" label="预约人数" :formatter="preengageNumberShow"></el-table-column>
          <el-table-column prop="hospital" align="center" label="医院名称"></el-table-column>
          <!-- <el-table-column prop="address" align="center" label="地址"></el-table-column> -->
          <el-table-column label="操作" align="center" min-width="120">
            <template slot-scope="scope">
              <el-link type="primary" style="margin:0 5px" @click="deleteClick(scope.row)">删除</el-link>
              <el-link type="primary" style="margin:0 5px" @click="checkInfo(scope.row)">查看预约详情</el-link>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          style="margin:20px 0;float:right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.page_n"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="query.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      query: {
        page_n: 1,
        page_size: 10,
      },
      total: 0,
    };
  },
  mounted() {
      this.getInfo()
  },
  methods: {
    getInfo() {
      this.$request.getNF(this.$url.type.base, this.$url.edu.projectList, this.query, response => {
        this.tableData = [];
        this.tableData = response.data
      });
    },
    editInfo(row) {
      this.$router.push("/eduHome/studentEdit/" + this.project.id + "/" + row.id);
    },
    indexShow(index) {
    //   return (this.query.page_n - 1) * this.query.page_size + index + 1;
        return index+1
    },
    preengageNumberShow(row){
        return row.number - row.remain_number
    },
    deleteClick(row) {
      this.$confirm('确定删除该日期"' + row.medical_exam_date + '"吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteInfo(row);
        })
        .catch(() => {});
    },
    addInfo(){
      this.$router.push('/eduHome/projectAdd')
    },
    deleteInfo(row) {
      this.$request.postFormNF(this.$url.type.base, this.$url.edu.projectDelete, { id: row.id }, success => {
        this.$message.success("删除成功");
        this.getInfo();
      });
    },
    checkInfo(row) {
      this.$router.push("/eduHome/projectDetail/" +  row.id);
    },
    handleCurrentChange(v) {
      this.query.page_n = v;
      this.getInfo();
    },
    handleSizeChange(v) {
      this.query.page_size = v;
      this.getInfo();
    },
  }
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
</style>
